import type { NodeData } from '../types/flow-types';

const NOTIFICATION_KIND_LABELS: Record<string, string> = {
	push_notification: 'Push Notification',
	mail_notification: 'Email Notification',
	event_log: 'Event Log',
	alexa_notif: 'Alexa Notification',
	alexa_notif_premium: 'Alexa Announcement',
};

export function resolvePushMessageType(
	data: Pick<NodeData, 'paletteKey'> & Record<string, unknown>,
): 'push' | 'alarm' {
	const raw = data.pushMsgType ?? data.msg_type ?? (data.sceneData as any)?.msg_type;
	if (raw === 'alarm' || data.paletteKey === 'pushAlarmNotification') return 'alarm';
	return 'push';
}

export function notificationSupportsCustomMessage(notificationType: string): boolean {
	return notificationType === 'push_notification' || notificationType === 'mail_notification';
}

export function resolveNotificationPaletteKey(
	notificationType: string,
	pushMessageType: 'push' | 'alarm' = 'push',
): string {
	if (notificationType === 'push_notification') {
		return pushMessageType === 'alarm' ? 'pushAlarmNotification' : 'notificationAction';
	}
	if (notificationType === 'mail_notification') return 'emailNotification';
	if (notificationType === 'event_log') return 'eventLogNotification';
	if (notificationType === 'alexa_notif' || notificationType === 'alexa_notif_premium') {
		return 'alexaNotification';
	}
	return 'notificationAction';
}

export function resolveNotificationKindLabel(data: NodeData): string {
	const notificationType = String(data.notificationType || 'push_notification');
	if (notificationType === 'push_notification' && resolvePushMessageType(data) === 'alarm') {
		return 'Push Alarm';
	}
	return NOTIFICATION_KIND_LABELS[notificationType] || String(data.typeLabel || 'Notification');
}

export function resolveNotificationCardPresentation(data: NodeData): {
	title: string;
	subtitle: string;
	kindLabel: string;
} {
	const notificationType = String(data.notificationType || 'push_notification');
	const kindLabel = resolveNotificationKindLabel(data);
	const message = notificationSupportsCustomMessage(notificationType)
		? String(data.notificationMessage || '').trim()
		: '';

	return {
		title: message || kindLabel,
		subtitle: message ? kindLabel : 'Notification action',
		kindLabel,
	};
}
